export const locationsRoutes = {
  create: [
    {
      path: 'location',
      loadComponent: () =>
        import('./pages/initial-location-step/initial-location-step.page').then(
          (m) => m.InitialLocationStepPage,
        ),
    },
  ],
  view: [
    {
      path: 'locations',
      children: [
        {
          path: '',
          title: `trip location`,
          loadComponent: () =>
            import('./pages/location-section/location-section.page').then(
              (m) => m.LocationSectionPage,
            ),
        },
        {
          path: 'edit',
          title: `Edit location`,
          loadComponent: () =>
            import('./pages/location-section/edit/edit.component').then((m) => m.EditLocationPage),
        },
      ],
    },
  ],
};
